import React, { useEffect, useState, useRef } from 'react';
import HeaderDashboard from '../../Components/DashboardComponent/headerdashboard/HeaderDashboard';
import Sidebar from '../../Components/DashboardComponent/sidebar/Sidebar';
import { useForm } from "react-hook-form";
import { ToastContainer } from 'react-toastify';
import swal from 'sweetalert';
import HttpHelper from '../../service/httpService'
import { CiEdit } from "react-icons/ci";
import { AiOutlineDelete } from "react-icons/ai";
import Loader from '../../Components/Loader';
import Accordion from 'react-bootstrap/Accordion';
import DashboardWrapper from './DashboardWrapper';
import { RxCross1, RxCross2 } from 'react-icons/rx';
import { hasAddPermission, hasDeletePermission, hasEditPermission, hasReadPermission, initilizeUserInfo } from "../../service/userService";
import { Editor, EditorTools, EditorUtils } from "@progress/kendo-react-editor";


const SecurityObjectName = 'Website.Testimonial';

const TestimonialTestimonial = (props) => {

    const {
        Bold,
        Italic,
        Underline,
        Strikethrough,
        Subscript,
        Superscript,
        AlignLeft,
        AlignCenter,
        AlignRight,
        AlignJustify,
        Indent,
        Outdent,
        OrderedList,
        UnorderedList,
        Undo,
        Redo,
        FontSize,FontName,
        FormatBlock,
        Link,
        Unlink,
        ViewHtml,
        InsertTable,
        AddRowBefore,
        AddRowAfter,
        AddColumnBefore,
        AddColumnAfter,
        DeleteRow,
        DeleteColumn,
        DeleteTable,
        MergeCells,
        SplitCell,
    } = EditorTools;

    const editor = useRef();
    const [contentData, setContentData] = useState("");
    const [hasReadPermissionUser, setHasReadPermissionUser] = useState('');
    const [hasAddPermissionUser, setHasAddPermissionUser] = useState('');
    const [hasEditPermissionUser, setHasEditPermissionUser] = useState('');
    const [hasDeletePermissionUser, setHasDeletePermissionUser] = useState('');

    const getAllPermission = () => {
        setHasReadPermissionUser(hasReadPermission(SecurityObjectName));
        setHasAddPermissionUser(hasAddPermission(SecurityObjectName));
        setHasEditPermissionUser(hasEditPermission(SecurityObjectName));
        setHasDeletePermissionUser(hasDeletePermission(SecurityObjectName));
    }

    const [popupAddEdit, setPopupAddEdit] = useState(false);
    const [loaderApi, setLoaderApi] = useState(false);

    const { register, handleSubmit, watch, reset, formState: { errors }, setValue, clearErrors } = useForm({});
    const formRef = useRef();
    const [testimonials, setTestimonials] = useState({});
    const [showLoader, setShowLoader] = useState(false);
    const [testimonialId, settestimonialId] = useState('');
    const [isEditing, setIsEditing] = useState(false);
    const [bannerImage, setBannerImage] = useState(null);
    const [imageCurrentShow, setImageCurrentShow] = useState('');
    const [showImgPopup, setShowImgPopup] = useState(false);
    const AccordianHandle = useRef();
    const [accordianStatus, setAccordianStatus] = useState('0');

    const [testimonialIdUpdate, settestimonialIdUpdate] = useState('');
    const [rowVersion, setRowVersion] = useState('');
    const [primaryKeyEncrypted, setPrimaryKeyEncrypted] = useState('');


    const onSubmit = async (data, event) => {
        setLoaderApi(true);
        if (isEditing === true) {
            testimonialUpdate(data, testimonialId)
        }
        else {
            testimonialAdd(data)
        }
    };

    const testimonialAdd = async (data) => {
        delete data.testimonialId
        await HttpHelper.post("Testimonial", data).then((response) => {
            props.showToast('success', 'Testimonial Added Succesfully');
            setLoaderApi(false);
            setPopupAddEdit(false);
            GetTestimonialList();
        }).catch((error) => {
            deleteUploadedFile(data.FileId)
            console.log(error);
        })
    }

    const testimonialUpdate = async (data, id, imageId) => {
        if (imageId === undefined) {
            Object.assign(data,
                { rowVersion: rowVersion },
                { TestimonialId: testimonialIdUpdate },
            );
        } else {
            Object.assign(data,
                { rowVersion: rowVersion },
                { FactId: testimonialIdUpdate },
            );
        }
        console.log(data)

        await HttpHelper.put("Testimonial", data).then((response) => {
            props.showToast('success', 'Testimonial Added Succesfully');
            setLoaderApi(false);
            setPopupAddEdit(false);
            GetTestimonialList();
            blankFormData()
        }).catch((error) => {
        })
    }

    const GetTestimonialList = async () => {
        setLoaderApi(true);
        await HttpHelper.get("Testimonial").then((response) => {
            if (response.status == 200) {
                setTestimonials(response.data.data);
                getAllPermission();
                setIsEditing(true);
                setLoaderApi(false);
            } else {
                console.info(response.data.data);
            }
        }).catch((error) => {
            console.log(error);
        })
    }

    const setTestimonialById = async (testimonialId) => {

        setPopupAddEdit(true);
        setLoaderApi(true);

        setIsEditing(true);
        setShowLoader(true);

        setValue('title', '');
        setValue('subTitle', '');
        setValue('description', '');
        setValue("testimonialId", '');
        settestimonialId('');
        setPrimaryKeyEncrypted('');
        setBannerImage('');

        await HttpHelper.get("Testimonial/" + testimonialId).then((response) => {
            if (response.status === 200) {
                settestimonialIdUpdate(response.data.testimonialId);
                setRowVersion(response.data.rowVersion)

                console.log(response.data);
                setValue('title', response.data.title);
                setValue('subTitle', response.data.subTitle);
                setValue('description', response.data.description);
                setContentData(response.data.description);
                setValue("testimonialId", response.data.testimonialId);
                settestimonialId(response.data.testimonialId);
                setPrimaryKeyEncrypted(response.data.primaryKeyEncrypted);
                accordianStatusHandle('1')
            }
            setShowLoader(false);
            setPopupAddEdit(true);
            setLoaderApi(false);
        }).catch((error) => {
            setShowLoader(false)
            console.log(error);
        })
    }

    const deleteTestimonial = async (testimonialId) => {
        swal("Are you sure, you want to delete this testimonial?", { buttons: ["Cancel", "Yes"] })
            .then(async (willDelete) => {
                if (willDelete) {
                    await HttpHelper.delete("Testimonial/" + testimonialId).then((response) => {
                        if (response.status === 200) {
                            GetTestimonialList();
                        }
                        props.showToast('success', 'Testimonial Deleted successfully');
                    }).catch((error) => {
                        console.log(error);
                    })
                }
            });
    }

    const blankFormData = () => {
        setIsEditing(false)
        setValue('title', '');
        setValue('subTitle', '');
        setValue('description', '');
        setContentData('');
    }

    const accordianStatusHandle = (elem) => {

        if (elem === undefined) {
            if (accordianStatus === '0') {
                setAccordianStatus('1');
            } else {
                setAccordianStatus('0');
            }
        } else {
            setAccordianStatus(elem);
        }
    }

    useEffect(() => {
        GetTestimonialList();
    }, []);

    return (
        <DashboardWrapper>
            <ToastContainer />
            <div className="DashboardWrapperChild">
                <Sidebar />
                <div className="contentWrapper">
                    <HeaderDashboard title="Testimonials" />
                    <div className="container-fluid mt-80 p-0">
                        <div className="row">
                            {hasAddPermissionUser == true ? <div className="col-auto">
                                {isEditing === true ? <button onClick={() => {
                                    setPopupAddEdit(true);
                                    blankFormData();
                                    accordianStatusHandle('1');
                                }} className="btn btnSave">Add Testimonial</button> : ''}
                            </div> : ''}
                            <div className="col-md-12 mb-2">
                            </div>
                            {hasAddPermissionUser == true && loaderApi == false ? <div className="col-md-12 mb-2 table-responsive">
                                <div className="cardBox cardTableWrapperDashboard cardTableGridNewDesign">
                                    <table className="table tableCustomized table-striped">
                                        <thead>
                                            <tr>
                                                <th>
                                                    title
                                                </th>
                                                <th>
                                                    Sun Title
                                                </th>
                                                <th>
                                                    Actions
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                //Sandeep: Testimonial Grid.
                                                testimonials.length > 0 ? testimonials.map((testimonial, index) => {
                                                    return (<tr key={index}>
                                                        <td>{testimonial.title}</td>
                                                        <td>{testimonial.subTitle}</td>
                                                        <td>
                                                            {hasEditPermissionUser == true ? <CiEdit onClick={() => { setTestimonialById(testimonial.testimonialId) }} /> : ''}
                                                            {hasDeletePermissionUser == true ? <AiOutlineDelete onClick={() => {
                                                                deleteTestimonial(testimonial.testimonialId)
                                                            }} /> : ''}
                                                        </td>
                                                    </tr>)
                                                })
                                                    : <tr><td colSpan="5">No data found!!!</td></tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div> : loaderApi == false && hasAddPermissionUser == false ? <div className="NoPermission">Don't Have Permisiion</div> : <div className="loaderApi">
                                <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#000">
                                    <g fill="none" fill-rule="evenodd">
                                        <g transform="translate(1 1)" stroke-width="2">
                                            <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                                            <path d="M36 18c0-9.94-8.06-18-18-18">
                                                <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                            </path>
                                        </g>
                                    </g>
                                </svg>
                            </div>}

                            <Accordion className="d-none" defaultActiveKey="0" activeKey={accordianStatus} ref={AccordianHandle}>
                                {hasReadPermissionUser == true ? <Accordion.Item eventKey="0" onClick={() => {
                                    accordianStatusHandle();
                                }}>
                                    <Accordion.Header>Testimonial Grid</Accordion.Header>
                                    <Accordion.Body onClick={(e) => {
                                        e.stopPropagation();
                                    }}>
                                        <div className="col-md-12 mb-2">
                                            <div className="cardBox cardTableWrapperDashboard">
                                                <div className="row">
                                                    <table className="table tableCustomized table-striped">
                                                        <thead>
                                                            <tr>
                                                                <th>
                                                                    Title
                                                                </th>
                                                                <th>
                                                                    Sub Title
                                                                </th>
                                                                <th>
                                                                    Actions
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                testimonials.length > 0 ? testimonials.map((testimonial, index) => {
                                                                    return (<tr key={index}>
                                                                        <td>{testimonial.title}</td>
                                                                        <td>
                                                                            {testimonial.subTitle}
                                                                        </td>
                                                                        <td>
                                                                            {hasEditPermissionUser == true ? <CiEdit onClick={() => { setTestimonialById(testimonial.testimonialId) }} /> : ''}
                                                                            {hasDeletePermissionUser == true ? <AiOutlineDelete onClick={() => {
                                                                                deleteTestimonial(testimonial.testimonialId)
                                                                            }} /> : ''}
                                                                        </td>
                                                                    </tr>)
                                                                })
                                                                    : <tr><td colSpan="5">No data found!!!</td></tr>
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item> : ''}
                            </Accordion>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`popupWrapperImage ${showImgPopup === true ? 'd-flex' : 'd-none'}`}>
                <div className="crossPopup" onClick={() => {
                    setShowImgPopup(false);
                    setImageCurrentShow('');
                }}>
                    <RxCross1 />
                </div>
                <img src={imageCurrentShow} />
            </div>
            {hasAddPermissionUser || hasEditPermissionUser ? <div className="popupEditAndAddFormWrapper" style={{ right: `${popupAddEdit == true ? '0' : '-100%'}` }}>
                <div className="popupEditAndAddForm">
                    <div className="popupEditAndAddFormCloseButton" onClick={() => {
                        setPopupAddEdit(false);
                        setIsEditing(true);
                    }} >
                        <RxCross2 />
                    </div>

                    {loaderApi == true ? <div className="loaderApi">
                        <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#000">
                            <g fill="none" fill-rule="evenodd">
                                <g transform="translate(1 1)" stroke-width="2">
                                    <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                                    <path d="M36 18c0-9.94-8.06-18-18-18">
                                        <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                    </path>
                                </g>
                            </g>
                        </svg>
                    </div>
                        :
                        <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
                            <div className="cardBox">
                                <h4>{isEditing === true ? "Update Testimonial" : "Add Testimonial"}</h4>
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>Title :</label>
                                        <input type="text"  {...register("title")} className="border mb-2" placeholder="title" />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Sub Title : </label>
                                        <input type="text"  {...register("subTitle")} className="border mb-2" placeholder="title" />
                                    </div>
                                    <div className="col-md-12">
                                        <label>Description : <span class="requiredAstric"> *</span></label>
                                        <Editor className="border" placeholder="Description"
                                            tools={[
                                                [Bold, Italic, Underline, Strikethrough],
                                                [Subscript, Superscript],
                                                [AlignLeft, AlignCenter, AlignRight, AlignJustify],
                                                [Indent, Outdent],
                                                [OrderedList, UnorderedList],
                                                FontSize,FontName,
                                                FormatBlock,
                                                [Undo, Redo],
                                                [Link, Unlink, ViewHtml],
                                                [InsertTable],
                                                [AddRowBefore, AddRowAfter, AddColumnBefore, AddColumnAfter],
                                                [DeleteRow, DeleteColumn, DeleteTable],
                                                [MergeCells, SplitCell],
                                            ]}
                                            ref={editor}
                                            defaultContent={contentData}
                                            onChange={(e) => {
                                                const regex = /(<([^>]+)>)/gi;
                                                const result = e.html.replace(regex, "");
                                                if (result.length > 0)
                                                    setValue('description', e.html);
                                                else
                                                    setValue('description', null);

                                            }}
                                        />
                                        <textarea className="border d-none" {...register("description", { required: true })} placeholder="description"></textarea>
                                        {errors.description?.type === 'required' && <p className="text-danger" role="alert">description is required</p>}
                                    </div>
                                    {
                                        isEditing === true ?
                                            <input type="hidden" {...register('testimonialId')} />
                                            : null
                                    }
                                    <div className="col-md-12 d-flex justify-content-end mt-3">
                                        <div>
                                            <button className="btn btnSave mt-2" >Save</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>}

                </div>
            </div> : ''}
        </DashboardWrapper>
    )
}

export default TestimonialTestimonial;